import { html, nothing, render } from "lit-html";
import { classMap } from "lit-html/directives/class-map.js";
import { stateful } from "@escapio/shared/components/element-builder";
import { linkTargetForProfile } from "@escapio/portal/components/hotel-list/get-offer-url";
import { getRecommendationText, TOP } from "../../HotelHighlightStates";
import { hasEscapioRate } from "@escapio/portal/state/escapio-deals-helpers";
import "./EscapioDealBadge";
import "../../HotelFavoriteStatus";
import { onChangeCurrency } from "@escapio/portal/state/travelData";

customElements.define(
	"esc-hotel-list-hotel-stage-desktop",
	stateful(
		class extends HTMLElement {
			static getInitialState() {
				return {
					isLoading: true,
				};
			}

			constructor() {
				super();
				this.gallery = null;
			}

			connectedCallback() {
				onChangeCurrency(() => this.render());
			}

			render() {
				const template = html`<a
					class="hotel-list-item-desktop__picture"
					href=${this.hotel.path}
					target=${linkTargetForProfile}
					@click=${() => this.profileLinkHandler(0)}
				>
					<esc-picture
						class=${classMap({
							"content-placeholder": this.isLoading,
						})}
						type="hotel"
						filename=${this.hotel.image.filename}
						alt=${this.hotel.image.alt}
						sizes="mobile:251x251"
						?onhold=${this.isLoading}
					></esc-picture>

					${hasEscapioRate(this.hotel) &&
					!this.hasAttribute("hide-escapio-deals-badges")
						? html`<esc-escapio-deal-badge></esc-escapio-deal-badge>`
						: this.hotel.review_score > 0
							? html`<div class="hotel-satisfaction is-translucent">
									<span class="fa fa-thumbs-o-up fa--space-after"></span>
									${this.hotel.review_score}%
								</div>`
							: nothing}
					<esc-hotel-favorite-status
						class="hotel-list-item-desktop__favorite is-translucent"
						hotel-id=${this.hotel.id}
						hotel-name=${this.hotel.name}
						only-icon
					>
					</esc-hotel-favorite-status>

					${(hasEscapioRate(this.hotel) &&
						!this.hasAttribute("hide-escapio-deals-badges")) ||
					this.type === TOP
						? html` <div
								class="${classMap({
									"hotel-list-item__image-recommendation": true,
									"hotel-list-item__image-recommendation--desktop": true,
									"hotel-list-item__image-recommendation--escapio-deal":
										hasEscapioRate(this.hotel),
								})}"
							>
								${getRecommendationText(this.type, this.hotel)}
							</div>`
						: nothing}
				</a>`;
				render(template, this, { host: this });
			}
		},
	),
);
